var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:[
    _vm.$style.typography,
    _vm.$variantStyle[_vm.variant],
    ( _obj = {}, _obj[_vm.$style.pre] = _vm.pre, _obj ) ]},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.formattedText))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }